import { KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';
import router from '@/router';
import { showTextModal } from '@/common/utils/ModalState';
import ServiceExec from '@/common/utils/ServiceExec';
import { businessUser } from '@/common/service/apiList';

export default [
  // 260626 비즈톡 Slice 3 — 영업형 사업장 1:1 채팅. 인증 필요(게스트는 가입 게이트). isHeader=앱 헤더('비즈톡').
  {
    path: '/talk',
    component: () => import('@/views/talk/TalkRooms.vue'),
    meta: { isHeader: true, isNav: false, isBack: true, titleName: '비즈톡' },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  {
    // 채팅방 — 자체 상단바(상대 이름 동적)라 isHeader:false
    path: '/talk/:roomNo',
    component: () => import('@/views/talk/TalkRoom.vue'),
    meta: { isHeader: false, isNav: false, isBack: true, titleName: '비즈톡' },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  {
    path: '/business',
    component: () => import('@/views/business/index.vue'),
    meta: {
      isHeader: false,
      isNav: true,
      isBack: false,
      titleName: '',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.BUSINESS_DETAIL.expression
    }
  },
  {
    path: '/business/my',
    component: () => import('@/views/business/my.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '나의 간판'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  // 260615 회의: 내 지역 홍보(디지털 전단지) — 기부 버튼 대체 진입점. 현재는 오픈 준비중 소개 랜딩만.
  // 대표 디자인이 자체 로고/헤드라인 보유 → 풀스크린(isHeader:false), 페이지 자체 뒤로가기 버튼.
  {
    path: '/business/local-promo',
    name: 'business-local-promo',
    component: () => import('@/views/business/localPromo.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: true,
      titleName: '내 지역 홍보'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/signboard/:businessNo',
    component: () => import('@/views/business/signboardManage.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '간판 관리'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/cooperation/inbox',
    component: () => import('@/views/business/cooperation/inbox.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '받은 제안'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  // 260526 보낸 제안함 (sent) — 받은 제안함 미러. businessNo=fromBusinessNo 기준.
  {
    path: '/business/cooperation/sent',
    component: () => import('@/views/business/cooperation/sentList.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '보낸 제안'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  // 260507 협업 제안 보내기 폼 + 상세 (회의 260506 오후)
  {
    path: '/business/cooperation/send',
    component: () => import('@/views/business/cooperation/send.vue'),
    meta: {
      isHeader: true, isNav: false, isBack: true, isHome: true,
      titleName: '협업・문의・상담 제안하기'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  {
    path: '/business/cooperation/detail/:proposalNo',
    component: () => import('@/views/business/cooperation/detail.vue'),
    meta: {
      isHeader: true, isNav: false, isBack: true, isHome: true,
      titleName: '받은 제안 상세'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  // 260526 보낸 제안 단건 상세 (발신자용) — detail.vue(수신자 전용)와 분리. fromBusiness owner만 BE에서 열람 허용.
  {
    path: '/business/cooperation/sent-detail/:proposalNo',
    component: () => import('@/views/business/cooperation/sentDetail.vue'),
    meta: {
      isHeader: true, isNav: false, isBack: true, isHome: true,
      titleName: '보낸 제안 상세'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  // 260507 구인 지원하기 + 받은 지원자 (회의 260506 오후)
  {
    path: '/business/job/apply/:jobNo',
    component: () => import('@/views/business/job/apply.vue'),
    meta: {
      isHeader: true, isNav: false, isBack: true, isHome: true,
      titleName: '지원하기'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  {
    path: '/business/job/applications/:jobNo',
    component: () => import('@/views/business/job/applications.vue'),
    meta: {
      isHeader: true, isNav: false, isBack: true, isHome: true,
      titleName: '받은 지원자'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  {
    path: '/business/job/application/detail/:applicationNo',
    component: () => import('@/views/business/job/applicationDetail.vue'),
    meta: {
      isHeader: true, isNav: false, isBack: true, isHome: true,
      titleName: '지원자 상세'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  // 260423: 간판 ON/OFF 허브 + 충전/설정/통계 독립 페이지 (고연령 친화 은행앱 스타일)
  // 260424 오후회의2: 커스텀 간판 제작 의뢰
  // 260513 feature flag 가드 — false면 진입 차단 + 준비중 모달.
  {
    path: '/business/signboard/:businessNo/custom-order',
    name: 'signboard-custom-order',
    component: () => import('@/views/business/signboard/on/CustomSignboardOrder.vue'),
    props: true,
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '커스텀 간판 제작 의뢰'
    },
    beforeEnter: async (to, from) => {
      // 260513 force=true — runtime toggle 즉시 반영 (DB row 변경 후 기존 세션 stale 방지)
      await store.dispatch('common/fetchFeatureFlags', { force: true });
      const flags = store.getters['common/getFeatureFlags'];
      if (!flags?.customDesignEnabled) {
        showTextModal('커스텀 디자인 의뢰는 현재 준비중이에요.\n곧 만나뵐게요.', '확인');
        // from이 있으면 그 자리에 머무름, 직접 URL 진입이면 메인으로
        return from?.name ? false : '/main';
      }
    }
  },
  // 260501 5/1 풀스코프: 간판온 알리기 (referral 공유 박스)
  // 체험/슈퍼 배터리 카드는 ChargeHub.vue 내부에 통합 (별도 BatteryHome 화면 폐기)
  {
    path: '/referral/share',
    name: 'referral-share',
    component: () => import('@/views/referral/ReferralShare.vue'),
    meta: { isHeader: false, isNav: false, isBack: true, titleName: '간판온 알리기' },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) router.push('/signin');
    }
  },
  // 260424 오후: 중간 허브(SignboardHub) 단계 제거 — 선택 리스트에서 charge로 직행
  {
    path: '/business/signboard/:businessNo/v2/:step(home|done)?',
    redirect: (to) => `/business/signboard/${to.params.businessNo}/charge`
  },
  {
    path: '/business/signboard/:businessNo/hub',
    redirect: (to) => `/business/signboard/${to.params.businessNo}/charge`
  },
  // 비즈니스 2개+인 경우 선택 페이지. ?target=charge|stats
  {
    path: '/business/signboard/select',
    name: 'signboard-business-select',
    component: () => import('@/views/business/signboard/on/SignboardBusinessSelect.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '간판 선택'
    },
    beforeEnter: async (to) => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        return '/signin';
      }
      // 260514 회의: 비즈 1개 + target=stats면 select 페이지 mount 자체 안 하고 통계로 직행 (빈 화면 플래시 X)
      if (to.query.target !== 'stats') return true;
      try {
        // 260610 보안 fix: 공유 피드 대신 owner 강제 /my/list로 단건 판별 (타 업체 통계 직행 누출 차단).
        const { status, data } = await ServiceExec.get(businessUser.getMyBusinessList, {
          page: 1,
          rowPerPage: 50
        });
        const rawList = (status === ServiceExec.status.OK && Array.isArray(data?.list)) ? data.list : [];
        if (rawList.length === 1 && rawList[0].authenticateStatus === 'SUCCESS') {
          // replace 옵션 제거 — 직전 entry(/more 등) 안 망가지게. 가드 redirect는 진입 type 그대로 따라감.
          return {
            name: 'signboard-stats-simple',
            params: { businessNo: String(rawList[0].businessNo) },
          };
        }
      } catch {}
      return true;
    }
  },
  // 260423 회의3: 라우트 분리 — 허브는 ON/OFF만, 배터리+4타일은 별도 charge-hub
  {
    path: '/business/signboard/:businessNo/charge',
    name: 'signboard-charge-hub',
    component: () => import('@/views/business/signboard/on/ChargeHub.vue'),
    props: true,
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      // 260612 typeC: Figma 타이틀 — 선택 리스트 진입 버튼('간판 설정 관리하기')과 통일
      titleName: '간판 설정 관리하기'
    }
  },
  {
    path: '/business/signboard/:businessNo/charge/share',
    name: 'signboard-charge-share',
    component: () => import('@/views/business/signboard/on/ChargeShare.vue'),
    props: true,
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '공유 충전'
    }
  },
  {
    path: '/business/signboard/:businessNo/charge/purchase',
    name: 'signboard-charge-purchase',
    component: () => import('@/views/business/signboard/on/ChargePurchase.vue'),
    props: true,
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '구매 충전'
    }
  },
  {
    path: '/business/signboard/:businessNo/charge/like',
    name: 'signboard-charge-like',
    component: () => import('@/views/business/signboard/on/ChargeLike.vue'),
    props: true,
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '좋아요 전환 충전'
    }
  },
  {
    path: '/business/signboard/:businessNo/schedule',
    name: 'signboard-schedule',
    component: () => import('@/views/business/signboard/on/ScheduleSetting.vue'),
    props: true,
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '간판 설정'
    }
  },
  {
    path: '/business/signboard/:businessNo/stats',
    name: 'signboard-stats-simple',
    component: () => import('@/views/business/signboard/on/StatsSimple.vue'),
    props: true,
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      // 260612 Figma main_typeC: '간판 통계' → '통계'
      titleName: '통계'
    }
  },
  {
    path: '/business/zone/:type(new|collab|event)',
    component: () => import('@/views/business/zonePage.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: true,
      titleName: 'ZONE'
    }
  },
  // 260530 테마 상세 — 테마(업종)별 업체 리스트 + 그 업종 진행중 이벤트 캐러셀
  {
    path: '/business/theme/:themeKey(food|play|shop|health|exercise|supply|expert|selfcare|jobs)',
    component: () => import('@/views/business/themeZone.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '테마'
    }
  },
  // 260522: 카카오 ghost detail page — 외부 카카오맵 이탈 차단 + 가입 prefill CTA (똑딱 모델)
  // sessionStorage('ghostDetailPayload')로 ghost 객체 전달, 없으면 main으로 fallback
  {
    path: '/business/ghost/detail',
    name: 'business-ghost-detail',
    component: () => import('@/views/business/ghostDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '간판 준비중'
    }
  },
  // 260605 기업↔기업 B2B 연결보드("원합니다") — 구인/협업 포맷 재사용 신규 보드.
  // ⚠️ /business/:businessNo catch-all(광범위)보다 반드시 "앞"에 등록. 정적/명시 경로를 먼저 두지 않으면 detail.vue로 오매칭.
  // 설계서 docs/0605_원합니다_구합니다_B2B연결보드_설계서.md §4-2.
  // 목록 — 비로그인 열람 허용(트래픽 확보). security.yaml 3곳 auth-ignore 등재는 BE 슬라이스에서.
  {
    path: '/business/wanted',
    component: () => import('@/views/business/wanted/list.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '함께하는 게시판'
    }
  },
  // 글 작성 — 로그인 가드(사업자 게이트는 화면 진입 시 getMyBusinessList로 추가 판별).
  // ⚠️ /business/wanted/:postNo(동적)보다 앞에 둬서 'write'가 postNo로 오매칭되지 않게.
  {
    path: '/business/wanted/write',
    component: () => import('@/views/business/wanted/write.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '글 올리기'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  // 받은 문의 인박스 — 로그인 필요. ⚠️ :postNo보다 앞.
  {
    path: '/business/wanted/inbox',
    component: () => import('@/views/business/wanted/inbox.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '받은 문의'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  // 받은 도움 요청 인박스 — 로그인 필요(사업자 게이트는 화면 onMounted). ⚠️ :postNo보다 앞(정적 'received').
  {
    path: '/business/wanted/received',
    component: () => import('@/views/business/wanted/received.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '받은 요청'
    }
  },
  // 문의 상세+읽음처리 — 로그인 필요. ⚠️ :postNo보다 앞(정적 prefix 'inquiry').
  {
    path: '/business/wanted/inquiry/:inquiryNo',
    component: () => import('@/views/business/wanted/inquiryDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '문의 상세'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  // 문의하기 폼 — 로그인+사업자 게이트(화면 진입 시 getMyBusinessList 판별).
  // 4세그먼트(:postNo/inquiry)라 3세그먼트 detail(:postNo)·inquiry detail과 충돌 없음. :postNo 상세보다 앞.
  {
    path: '/business/wanted/:postNo/inquiry',
    component: () => import('@/views/business/wanted/inquiry.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '문의하기'
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  // 상세 — 비로그인 열람 허용. ⚠️ 같은 prefix의 동적 라우트는 write/inbox/inquiry 뒤, 그러나 :businessNo catch-all 앞.
  {
    path: '/business/wanted/:postNo',
    component: () => import('@/views/business/wanted/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '함께하는 게시판'
    }
  },
  // 260622 회의: 모바일 창업관 — 프랜차이즈 본사 입점/노출 보드 (FE-first MVP, 임시 샘플 데이터).
  // ⚠️ /business/:businessNo catch-all보다 반드시 "앞"에 등록(정적/명시 경로 먼저). wanted 보드와 동일 규율.
  // 목록 — 비로그인 열람 허용(트래픽 확보).
  {
    path: '/business/franchise',
    component: () => import('@/views/business/franchise/list.vue'),
    meta: {
      // 260624 리뉴얼: 그린 그라데이션이 상단(헤더 뒤)부터 흐르도록 자체 헤더 사용. 전역 흰 헤더 미사용(zonePage 패턴).
      isHeader: false,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '모바일 창업관'
    }
  },
  // 창업 정보 등록 — ⚠️ :franchiseId(동적)보다 앞(정적 'register' 오매칭 방지).
  // MVP scaffold: 디자이너 테섭 리뷰를 위해 로그인 가드 미적용(폼 자유 열람). BE 연동(P2) 시 owner 게이트 복원.
  {
    path: '/business/franchise/register',
    component: () => import('@/views/business/franchise/register.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '창업관 등록'
    }
  },
  // 창업 정보 상세 — 비로그인 열람 허용.
  {
    path: '/business/franchise/:franchiseId',
    component: () => import('@/views/business/franchise/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '창업 정보'
    }
  },
  {
    path: '/business/:businessNo',
    component: () => import('@/views/business/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: false,
      titleName: '',
      isGlass: true, // 260611 시안: 히어로 간판사진이 헤더 뒤까지 — 반투명 블러 헤더(Andersen 패턴)
      isSearchHeader: false,
      isBusinessLike: true,
      isBusinessSubscribe: true,
      // 260423 오후 회의: 상단 공유/카톡 버튼 제거 — 본문의 4칸 공유 그리드(카톡/문자/FB/IG)와 중복
      // 260524: expression 제거 — keep-alive로 일반 detail 부활 시 일부 state만 살아남는 race로
      // 카테고리 검색 list만 비어있는 어색한 상태 발생. ghost detail(expression 없음)과 동일하게
      // fresh mount → store init → fetch로 깔끔한 그리드 화면 표시 (사용자 선호 동작 일치)
    }
  },
  {
    path: '/business/share/:businessNo',
    component: () => import('@/views/business/shareDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: false,
      isHome: false,
      titleName: '',
      isSearchHeader: false,
      isBusinessLike: true,
      isBusinessKakaoShare: true,
      expression: KEEP_ALIVE_OBJECT.BUSINESS_DETAIL.expression
    }
  },
  {
    path: '/business/register/new',
    component: () => import('@/views/business/register/registerNew.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '비즈니스 등록하기',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.BUSINESS_REGISTER.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/edit/:businessNo',
    component: () => import('@/views/business/register/registerEdit.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '비즈니스 수정하기',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.BUSINESS_UPDATE.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  // 260515: 최초 수정 진입 시 스와이프 마법사 (은행앱 가이드 스타일).
  // 마법사 완료/리스트로 보기 클릭 시 localStorage 마킹 → 이후 진입은 리스트형(registerEdit).
  {
    path: '/business/edit/:businessNo/wizard',
    component: () => import('@/views/business/register/businessEditWizard.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '비즈니스 수정하기',
      isSearchHeader: false,
      expression: KEEP_ALIVE_OBJECT.BUSINESS_UPDATE.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/marketing/register/:businessNo',
    component: () => import('@/views/business/marketing/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '이벤트 알림 등록하기',
      expression: KEEP_ALIVE_OBJECT.MARKETING_REGISTER.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/marketing/update/:marketingNo',
    component: () => import('@/views/business/marketing/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '마케팅 수정하기',
      expression: KEEP_ALIVE_OBJECT.MARKETING_REGISTER.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/marketing/preview',
    component: () => import('@/views/business/marketing/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '미리보기',
      expression: KEEP_ALIVE_OBJECT.MARKETING_REGISTER.expression
    }
  },
  {
    path: '/business/marketing/:marketingNo',
    component: () => import('@/views/business/marketing/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isBusinessMarketingShare: true,
      isBusinessMarketingKakaoShare: true,
      titleName: ''
    }
  },

  {
    path: '/business/marketing/share/:marketingNo',
    component: () => import('@/views/business/marketing/shareDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      // 260511 오후: NOW 이벤트 등 내부 진입 케이스에서 뒤로가기 필요. 카톡 외부 진입에도 history.back으로 자연 동작.
      isBack: true,
      titleName: '',
      isBusinessMarketingKakaoShare: true
    }
  },
  {
    path: '/business/marketing/purchase',
    component: () => import('@/views/business/marketing/purchase.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '이벤트 알림권 구매 내역',
      isHome: true
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/donation/register/:businessNo',
    component: () => import('@/views/business/donation/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '기부 내용 등록하기',
      expression: KEEP_ALIVE_OBJECT.DONATION_REGISTER.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/donation/preview',
    component: () => import('@/views/business/donation/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '미리보기',
      expression: KEEP_ALIVE_OBJECT.DONATION_REGISTER.expression
    }
  },
  {
    path: '/business/donation/:donationNo',
    component: () => import('@/views/business/donation/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isBusinessDonationShare: true,
      isBusinessDonationKakaoShare: true,
      titleName: ''
    }
  },
  {
    path: '/business/donation/update/:donationNo',
    component: () => import('@/views/business/donation/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '기부 내용 수정하기',
      expression: KEEP_ALIVE_OBJECT.DONATION_REGISTER.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/donation/share/:donationNo',
    component: () => import('@/views/business/donation/shareDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: false,
      titleName: '',
      isBusinessDonationKakaoShare: true
    }
  },
  {
    path: '/business/job/register/:businessNo',
    component: () => import('@/views/business/job/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '구인 내용 등록하기',
      expression: KEEP_ALIVE_OBJECT.DONATION_REGISTER.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/job/preview',
    component: () => import('@/views/business/job/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '미리보기',
      expression: KEEP_ALIVE_OBJECT.JOB_REGISTER.expression
    }
  },
  {
    path: '/business/job/:jobNo',
    component: () => import('@/views/business/job/detail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isBusinessJobShare: true,
      isBusinessJobKakaoShare: true,
      titleName: ''
    }
  },
  {
    path: '/business/job/update/:jobNo',
    component: () => import('@/views/business/job/register.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '구인 내용 수정하기',
      expression: KEEP_ALIVE_OBJECT.DONATION_REGISTER.expression
    },
    beforeEnter: () => {
      const user = store.getters['user/getUserData'];
      if (isEmpty(user.userNo)) {
        router.push('/signin');
      }
    }
  },
  {
    path: '/business/job/share/:jobNo',
    component: () => import('@/views/business/job/shareDetail.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: false,
      titleName: '',
      isBusinessJobKakaoShare: true,
    }
  }
];
